// useScript hooks

import { useEffect, useRef, useState } from 'react';

/**
 *
 * @param src script 地址 ;
 * @param condition 为true时加载script
 * @param loadedCallback script加载完成后的回调
 * @returns
 */
export default function useScript(src: string, condition: boolean, loadedCallback?: () => void) {
  const [status, setStatus] = useState({
    loaded: false,
    error: false
  });
  const randomScriptId = useRef(`script-id-${Math.random().toString(36).substring(7)}`);

  useEffect(() => {
    if (!condition) return;
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.id = randomScriptId.current;

    const onLoad = () => {
      setStatus({
        loaded: true,
        error: false
      });
      loadedCallback?.();
    };

    const onError = () => {
      const script = document.getElementsByTagName('script')[0];
      script.parentNode.removeChild(script);
      setStatus({
        loaded: true,
        error: true
      });
    };

    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);

    if (!document.getElementById(randomScriptId.current)) {
      document.body.appendChild(script);
    }

    return () => {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
    };
  }, []);

  if (!condition) {
    return [false, false];
  }

  return [status.loaded, status.error];
}

export const loadScript = (src: string, scriptId: string, loadedCallback?: () => void) => {
  const script = document.createElement('script');
  script.src = src;
  script.id = scriptId;

  const onLoad = () => {
    loadedCallback?.();
  };

  const onError = () => {
    const script = document.getElementsByTagName('script')[0];
    script.parentNode.removeChild(script);
  };

  script.addEventListener('load', onLoad);
  script.addEventListener('error', onError);

  if (!document.getElementById(scriptId)) {
    document.body.appendChild(script);
  }
};
